module.exports = __webpack_public_path__ + "img/about_logo_20.c9640a4b.png";